// import './Scene.css';
import { Entity, Scene } from 'aframe-react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

/* Images for local testing */
//import ImgVPalue from '../img/viewpoints/202410-aula.jpg';
//import ImgVPsp from '../img/viewpoints/202410-sustainable_production.jpg';
//import ImgVPlvl from '../img/viewpoints/202410-lvl.jpg';
//import ImgVPvp from '../img/viewpoints/202410-veneer_peeling.jpg';
//import ImgVPkonesali from '../img/viewpoints/202410-konesali.jpg';
//import ImgVPparvi from '../img/viewpoints/202410-parvi.jpg';

const AScene = ({ hotspotList, sceneLoaded }) => {

    const [hotspots, setHotspots] = useState([])

    console.log("rendered Ascene")

    // Communicate upwards that scene was loaded
    useEffect( () => {
        sceneLoaded();
    }, [hotspots, sceneLoaded]);

    const createHotspots = () => {
        const createdHotspots = hotspotList.map(group => {
            let allSpots = group.viewpoint_data.concat(group.hotspot_data || [])
            const groupEntities = allSpots.map( spot => {
                const hotspotData = `pointName: ${spot.name};
                    groupIndex: ${group.groupIndex}; 
                    pointIndex: ${spot.index};
                    type: ${spot.type};
                    linkToViewpoint: ${spot.linkToViewpoint || ""}; 
                    inViewpoint: ${spot.inViewpoint || ""}`;
                const hotspotPos = `${spot.position.x} ${spot.position.y} ${spot.position.z}`;
                return <Entity 
                    // primitive="a-image"
                    id={spot.name}
                    key={group.groupName + '_' + spot.name}
                    hotspot={hotspotData}
                    position={hotspotPos}
                />
            })
            let groupNameMod = group.groupName.replace(/\s+/g, '-').replace(',', '').toLowerCase();
            return (
                <Entity 
                    id={groupNameMod} 
                    key={groupNameMod} 
                    scale={(groupNameMod === window.activeViewpoint || "lobby") ? "1 1 1" : "0 0 0"}
                    hotspotgroup={`name: ${groupNameMod}`}>
                    {groupEntities}
                </Entity>
            )
        })
        setHotspots(createdHotspots);
        return createdHotspots;
    }

    return (
        <Scene background="color: #ECECEC" vr-mode-ui="enabled: false" loading-screen="dotsColor: #007CB0; backgroundColor: #efeef1">

            {/* Only the lobby image is an asset, which is loaded before startup */}
            <a-assets timeout={10000}>
                <img id="img-lobby" src="https://materials.raute.com/pub/system/RX+Showroom/viewpoints/202410-aula.jpg" crossOrigin="" alt="background img"/>
                {/* <img id="img-hotspot" src="https://showroom-hubspot-test.s3-eu-west-1.amazonaws.com/aframe-tester/img-smaller/map-marker-alt-solid.svg" crossOrigin="anonymous" alt="hotspot icon"/> */}
                {/* <img id="img-lobby" src={ImgVPalue} crossOrigin="" alt="background img"/>  */}
            </a-assets>

            <a-sky id="skybox" src="#img-lobby"></a-sky>

            {/* Other showroom 360 images */}
            {/* Raute server path: https://materials.raute.com/pub/system/RX+Showroom/viewpoints/ */}
            <img id="img-sustainable-production" src="https://materials.raute.com/pub/system/RX+Showroom/viewpoints/202410-sustainable-production.jpg" crossOrigin="" alt="background img"/>
            <img id="img-lvl" src="https://materials.raute.com/pub/system/RX+Showroom/viewpoints/202410-lvl.jpg" crossOrigin="" alt="background img"/>
            <img id="img-veneer-peeling" src="https://materials.raute.com/pub/system/RX+Showroom/viewpoints/202410-veneer_peeling.jpg" crossOrigin="" alt="background img"/>
            <img id="img-future-mill" src="https://materials.raute.com/pub/system/RX+Showroom/viewpoints/202410-konesali.jpg" crossOrigin="" alt="background img"/>
            <img id="img-data-driven-production" src="https://materials.raute.com/pub/system/RX+Showroom/viewpoints/202410-parvi.jpg" crossOrigin="" alt="background img"/>
            {/* <img id="img-follow-demos" src="https://materials.raute.com/pub/system/RX+Showroom/viewpoints/demos_final_bonus_TAPAHTUMANJALKEEN_laatu8.jpg" crossOrigin="anonymous" crossOrigin="" alt="background img"/> */}

            {/* For local testing
            <img id="img-sustainable-production" src={ImgVPsp} crossOrigin="" alt="background img"/>
            <img id="img-lvl" src={ImgVPlvl} crossOrigin="" alt="background img"/>
            <img id="img-veneer-peeling" src={ImgVPvp} crossOrigin="" alt="background img"/>
            <img id="img-future-mill" src={ImgVPkonesali} crossOrigin="" alt="background img"/>
            <img id="img-data-driven-production" src={ImgVPparvi} crossOrigin="" alt="background img"/>
            */}

            {/* <a-box position="-1 0.5 -3" rotation="0 45 0" height="0.05" width="0.05" depth="0.05" color="#006298" shadow></a-box> */}

            <Entity rotation="0 90 0">
                <Entity id="cam" primitive="a-camera" position="0 1.6 0">
                    {/* Dummy sphere to help with fading out */}
                    <a-plane id="dummy-sphere" position="0 0 -0.3" color="#000000" material="shader: standard; opacity: 0" 
                        animation__fadeoutandin="startEvents: fadeoutandin; property: material.opacity; from: 0; to: 1; dur: 1000; dir: alternate; loop: 2;"
                        >
                    </a-plane>
                </Entity>
            </Entity>


            <Entity id="viewpoint-controller" viewpointcontroller>
                { (hotspots.length > 0) ? hotspots : createHotspots() } 
            </Entity>
        </Scene>
    );
}


AScene.propTypes = {
    hotspotList: PropTypes.array,
    sceneLoaded: PropTypes.func
}


export default AScene;
